export default "__VITE_ASSET__ce63865e__"